import { Studente } from '../../interfaces/studente-figlio.interface';

export type ActionType =
  | 'assenza' | 'pasta-in-bianco'
  | 'rimuovi-assenza' | 'rimuovi-pasta-in-bianco'
  | 'genera-pagamento' | 'navigazione-pagamenti';

export const INTENT_LABELS: Record<ActionType, string> = {
  'assenza': 'Assenza',
  'pasta-in-bianco': 'Pasta in Bianco',
  'rimuovi-assenza': 'Rimuovi Assenza',
  'rimuovi-pasta-in-bianco': 'Rimuovi Pasta in Bianco',
  'genera-pagamento': 'Genera Pagamento',
  'navigazione-pagamenti': 'Vai ai Pagamenti',
};

export function isActionType(value: string): value is ActionType {
  return value === 'assenza' || value === 'pasta-in-bianco'
    || value === 'rimuovi-assenza' || value === 'rimuovi-pasta-in-bianco'
    || value === 'genera-pagamento' || value === 'navigazione-pagamenti';
}

export function isRemoveAction(actionType: ActionType | null): boolean {
  return actionType === 'rimuovi-assenza' || actionType === 'rimuovi-pasta-in-bianco';
}

export function isPaymentAction(actionType: ActionType | null): boolean {
  return actionType === 'genera-pagamento';
}

export function isNavigationAction(actionType: ActionType | null): boolean {
  return actionType === 'navigazione-pagamenti';
}

export type TokenStatus = 'matched' | 'fuzzy' | 'unmatched';

export type ParseConfidence = 'full' | 'partial' | 'none';

export interface ParsedToken {
  raw: string;
  type: 'intent' | 'figlio' | 'data' | 'importo' | 'noise';
  resolved: string;
  status: TokenStatus;
}

export interface DateMatch {
  inizio: Date;
  fine?: Date;
}

export interface ChildMatch {
  studente: Studente;
  status: 'matched' | 'fuzzy';
  originalInput?: string;
}

export interface ParseResult {
  intent: ActionType | null;
  figlio: Studente | null;
  figlioAutoSelected: boolean;
  childMatch: ChildMatch | null;
  data: DateMatch | null;
  importo: number | null;
  confidence: ParseConfidence;
  tokens: ParsedToken[];
}

const euroFormatter = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' });

export function formatEuro(value: number): string {
  return euroFormatter.format(value);
}

export function computeConfidence(result: Pick<ParseResult, 'intent' | 'figlio' | 'data' | 'importo'>): ParseConfidence {
  if (!result.intent) return 'none';
  if (result.figlio && isPaymentAction(result.intent) && result.importo !== null) return 'full';
  if (result.figlio && result.data) return 'full';
  return 'partial';
}
